if (!customElements.get('copy-code-button')) {
  customElements.define(
    'copy-code-button',
    class CopyCodeButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.code = this.dataset.code || '';
        this.defaultLabel = this.button?.textContent.trim();
        this.button?.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick() {
        if (!this.code) return;

        const done = () => {
          if (!this.button) return;
          this.button.textContent = this.dataset.copiedLabel || 'Copié !';
          clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => {
            if (this.button) this.button.textContent = this.defaultLabel;
          }, 2000);
        };

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(this.code).then(done).catch(() => this.fallbackCopy(done));
        } else {
          this.fallbackCopy(done);
        }
      }

      fallbackCopy(done) {
        const textarea = document.createElement('textarea');
        textarea.value = this.code;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          done();
        } catch (e) {
          // Copy genuinely unsupported — the code text is already visible
          // on screen for manual selection, nothing else to do.
        }
        document.body.removeChild(textarea);
      }
    }
  );
}
